import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { STRIPE_PRICE_MAP } from '../../lib/stripePriceMap'

/** Builds the enroll-link package key for a timed tier, e.g. 'proLook' + 12 -> 'proLook-12w'. */
export const tierKey = (base: string, weeks?: number) => (weeks ? `${base}-${weeks}w` : base)

/**
 * Links to the Stripe-driven enrollment flow for a pricing tier. Renders
 * nothing if that tier's Stripe Price ID hasn't been configured yet, so a
 * pricing page never shows a button that would fail at checkout.
 */
export const EnrollLink: React.FC<{ packageKey: string; className?: string }> = ({
  packageKey,
  className,
}) => {
  const pkg = STRIPE_PRICE_MAP[packageKey]
  if (!pkg || !pkg.priceId) return null

  return (
    <Link
      to={packageKey === 'strongAgain' ? '/strong-again/enroll' : `/enroll/${packageKey}`}
      className={
        className ||
        'inline-flex items-center justify-center rounded-full border-2 border-brand-navy text-brand-navy font-bold px-5 py-2.5 text-sm transition-all duration-300 hover:bg-brand-navy hover:text-brand-cream'
      }
    >
      Enroll Now
      <ArrowRight className="ml-1.5" size={15} />
    </Link>
  )
}
